export default __webpack_public_path__ + "c98e48af935844275d2e4d4bd66824ea.png";